<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <b-card-title class="font-18 font-weight-bold">
                Thống kê truy cập theo thời gian</b-card-title
            >
            <b-card-group class="mt-2" deck>
                <b-card border-variant="light" class="card-doc">
                    <b-card-title class="font-18 font-weight-bold">
                        <i class="fa fa-calendar fa-lg mr-2" /> Theo ngày
                        <span class="ml-2"> {{ listAnalyze.today }}</span></b-card-title
                    >
                </b-card>
                <b-card border-variant="light" class="card-doc">
                    <b-card-title class="font-18 font-weight-bold">
                        <i class="fa fa-calendar fa-lg mr-2" /> Theo tuần
                        <span class="ml-2"> {{ listAnalyze.week }}</span></b-card-title
                    >
                </b-card>
                <b-card border-variant="light" class="card-doc">
                    <b-card-title class="font-18 font-weight-bold">
                        <i class="fa fa-calendar fa-lg mr-2" /> Theo tháng
                        <span class="ml-2"> {{ listAnalyze.month }}</span></b-card-title
                    >
                </b-card>
                <b-card border-variant="light" class="card-doc">
                    <b-card-title class="font-18 font-weight-bold">
                        <i class="fa fa-calendar fa-lg mr-2" /> Theo năm
                        <span class="ml-2"> {{ listAnalyze.year }}</span></b-card-title
                    >
                </b-card>
            </b-card-group>
            <div class="d-flex content-action align-items-center mt-4">
                <div class="d-flex align-items-center text-nowrap">
                    <b-button variant="outline-primary" class="mr-1" @click="openCreateNewsModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Thêm tin tức</span>
                    </b-button>

                    <b-button variant="info" class="mr-1" @click="showModalAbout = true">
                        <i class="fa fa-pencil mr-2"></i>
                        <span class="text-uppercase">Cập nhật trang giới thiệu</span>
                    </b-button>

                    <b-button variant="warning" @click="openCreateDocsModal">
                        <i class="fa fa-pencil mr-2"></i>
                        <span class="text-uppercase">Thêm văn bản chỉ đạo</span>
                    </b-button>
                </div>
            </div>

            <b-tabs
                class="mt-2"
                content-class="tab-content-custom"
                justified
                active-nav-item-class="font-weight-bold text-uppercase text-primary"
            >
                <b-tab title="Tin hoạt động" active>
                    <TableListNews
                        :items="items.filter((item) => item.type === CONSTANTS.NEWS_TYPE[0].value)"
                    />
                </b-tab>
                <b-tab title="Tin cảnh báo">
                    <TableListNews
                        :items="items.filter((item) => item.type === CONSTANTS.NEWS_TYPE[1].value)"
                    />
                </b-tab>
                <b-tab title="Văn bản chỉ đạo">
                    <TableListNews :items="items.filter((item) => item.type === 'DOCUMENT')" />
                </b-tab>
            </b-tabs>
        </div>

        <!-- Create/Edit Info -->
        <b-modal
            ref="createOrUpdateModal"
            :ok-title="$t('common.create')"
            :title="`${isCreateDoc ? 'Tạo mới văn bản' : 'Tạo mới tin tức'}`"
            :cancel-title="$t('common.cancel')"
            @ok="handleOk"
            no-close-on-esc
            no-close-on-backdrop
            size="xl"
        >
            <b-form-group :label="$t('common.name')">
                <b-form-textarea
                    maxlength="255"
                    v-model="itemInfo.name"
                    v-validate="'required'"
                    :placeholder="$t('common.name')"
                    name="name"
                    rows="3"
                    :data-vv-as="$t('common.name')"
                />
                <div v-show="errors.has('name')" class="validation-message text-danger">
                    Tên bài viết là trường bắt buộc
                </div>
            </b-form-group>
            <b-form-group label="Mô tả ngắn gọn">
                <VueEditor
                    :value="itemInfo.sapo"
                    :placeholder="'Mô tả ngắn gọn'"
                    @change="(data) => (itemInfo.sapo = data)"
                />
            </b-form-group>
            <b-form-group label="Nguồn bài viết/tác giả">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.author"
                    placeholder="Nguồn bài viết/tác giả"
                    name="author"
                />
            </b-form-group>
            <b-form-group label="Ảnh nền">
                <b-form-file
                    v-model="selectedAvatar"
                    accept="image/*"
                    placeholder="Chọn ảnh nền tải lên"
                    browse-text="Chọn tệp"
                />
            </b-form-group>
            <b-form-group label="Tệp đính kèm">
                <b-form-file
                    v-model="listSelectedFiles"
                    :accept="isCreateDoc ? '.pdf' : '.pdf, image/*, .doc, .docx'"
                    placeholder="Chọn văn bản tải lên"
                    browse-text="Chọn tệp"
                    multiple
                />
            </b-form-group>
            <b-form-group label="Nội dung bài viết">
                <VueEditor
                    :value="itemInfo.content"
                    :placeholder="'Nội dung'"
                    @change="(data) => (itemInfo.content = data)"
                />
            </b-form-group>
            <b-form-group label="Ngày xuất bản">
                <date-picker
                    v-model="itemInfo.date"
                    value-type="format"
                    :format="'DD/MM/YYYY HH:mm:ss'"
                    lang="en"
                    type="datetime"
                    input-class="form-control bg-white"
                    :editable="false"
                    :clearable="false"
                    placeholder="Chọn thời gian"
                    showSecond
                />
            </b-form-group>
            <div v-if="!isCreateDoc">
                <b-form-group label="Trạng thái">
                    <b-form-radio-group
                        v-model="itemInfo.status"
                        :options="CONSTANTS.NEWS_STATUS"
                        name="radio-status"
                    />
                </b-form-group>
                <b-form-group label="Kiểu tin tức">
                    <b-form-radio-group
                        v-model="itemInfo.type"
                        :options="CONSTANTS.NEWS_TYPE"
                        name="radio-type"
                    />
                </b-form-group>
            </div>
        </b-modal>

        <!-- Edit About page content -->
        <b-modal
            :visible="showModalAbout"
            :ok-title="$t('common.update')"
            :title="'Cập nhật nội dung'"
            :cancel-title="$t('common.cancel')"
            @ok="onSaveAboutContent"
            no-close-on-esc
            no-close-on-backdrop
            size="xl"
        >
            <VueEditor
                :value="recordAboutPage.content"
                :placeholder="'Nội dung'"
                @change="(data) => (recordAboutPage.content = data)"
            />
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CONSTANTS from '@/constants';
import TableListNews from '@/components/TableListNews';
import Document from '@/components/Document';
import VueEditor from '@/components/VueEditor';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    components: { TableListNews, VueEditor, Document, DatePicker },
    async mounted() {
        await this.$nextTick();
        await this.getList();
        this.getListUsers();
        this.getListAnalyze();
        this.recordAboutPage = this.items.filter((item) => item.type === 'GIOI_THIEU')[0];
    },
    computed: {
        ...mapState({
            items: (state) => state.news.items,
            listAnalyze: (state) => state.news.listAnalyze,
            listUsers: (state) => state.user.users
        })
    },
    data() {
        return {
            itemInfo: {},
            CONSTANTS,
            recordAboutPage: {
                content: ''
            },
            showModalAbout: false,
            isCreateDoc: false,
            listSelectedFiles: [],
            selectedAvatar: null
        };
    },
    methods: {
        ...mapActions({
            getList: 'news/getList',
            getListAnalyze: 'news/getListAnalyze',
            updateOrCreate: 'news/updateOrCreate',
            createDoc: 'news/createDoc',
            getInfo: 'news/getInfo',
            createAuditByUser: 'user/createAuditByUser',
            getListUsers: 'user/getListUsers',
            uploadImage: 'news/uploadImage'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.onSubmit('news');
        },
        onSubmit(type) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.add(type);
                    this.$refs.createOrUpdateModal.hide();
                    if (type != 'news') this.isCreateDoc = false;
                    this.$toaster.success(
                        type == 'news' ? 'Tạo tin tức thành công' : 'Tạo văn bản thành công'
                    );
                    this.createAuditByUser({
                        content: type == 'news' ? 'Tạo tin tức' : 'Tạo văn bản chỉ đạo'
                    });
                }
            });
        },
        async add(type) {
            let avatarRes = null;
            let listAttachFiles = [];
            if (this.selectedAvatar) {
                const formData = new FormData();
                formData.append('file', this.selectedAvatar);
                const res = await this.uploadImage(formData);
                avatarRes = res.url;
            }
            if (this.listSelectedFiles.length) {
                for (let i = 0; i < this.listSelectedFiles.length; i++) {
                    const element = this.listSelectedFiles[i];
                    const formData = new FormData();
                    formData.append('file', element);
                    const res = await this.uploadImage(formData);
                    listAttachFiles.push(res.url);
                }
            }
            this.itemInfo.avatar = avatarRes ? avatarRes : this.itemInfo.avatar;
            this.itemInfo.files = listAttachFiles ? listAttachFiles : this.itemInfo.files;
            delete this.itemInfo.id;
            this.itemInfo.date =
                this.$moment(this.itemInfo.date, 'DD/MM/YYYY HH:mm:ss')
                    .toISOString()
                    .split('.')[0] + 'Z';
            if (type != 'news') {
                this.itemInfo.status = 'PUBLISH';
                this.itemInfo.type = 'DOCUMENT';
            }
            await this.updateOrCreate(this.itemInfo);
        },
        async onSaveAboutContent() {
            await this.updateOrCreate(this.recordAboutPage);
            this.$toaster.success('Cập nhật nội dung thành công');
            this.createAuditByUser({ content: 'Sửa nội dung trang giới thiệu' });
        },
        openCreateNewsModal() {
            this.resetForm();
            this.$refs.createOrUpdateModal.show();
        },
        openCreateDocsModal() {
            this.resetForm();
            this.isCreateDoc = true;
            this.$refs.createOrUpdateModal.show();
        },
        resetForm() {
            this.selectedAvatar = null;
            this.listSelectedFiles = [];
            this.itemInfo = {
                status: CONSTANTS.NEWS_STATUS[0].value,
                type: CONSTANTS.NEWS_TYPE[0].value
            };
        },
        async onSaveDocs(modal) {
            modal.preventDefault();
            this.onSubmit('document');
        },
        handleOk(modal) {
            if (this.isCreateDoc) this.onSaveDocs(modal);
            else this.handleCreateOk(modal);
        }
    }
};
</script>
